import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TutorialPage } from './tutorial.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { TutorialSlideComponent } from 'src/app/components/tutorial-slide/tutorial-slide.component';

const homeRoutes: Routes = [
  {
    path: '',
    component: TutorialPage,
  },
];
@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, RouterModule.forChild(homeRoutes), ComponentsModule],
  declarations: [TutorialPage,
    TutorialSlideComponent
  ],
})
export class TutorialPageModule {}
